<template>
    <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 800 600"
        class="woom-bike-outline woom-original-6"
        x="0px"
        y="0px"
        style="enable-background: new 0 0 800 600"
        xml:space="preserve"
        v-once>
        <g class="bike">
            <path
                class="fill-none stroke-woom-black stroke-2"
                d="M317.4,277.2c-0.7,0.3-128.7,66.2-133.3,69s-8.6,5.8-8.6,9c0,3.1,2.5,6.2,9.3,7.2s163.9,24.5,163.9,24.5
                  L317.4,277.2z" />
            <path
                class="fill-none stroke-woom-black stroke-2"
                d="M355.4,403.2c0,0-183.8-35.1-186.7-35.7c-2.9-0.5,1.6-6.4,2.2-9.2c0.6-2.7,0.1-4.6-1.8-5.4
                  c-1.9-0.8-5.1,3.1-6.4,4.6s-3.8-1.4-2.7-3.6c1.1-2.3,11.5-7.9,11.5-7.9l143.2-78l-17.1-53.5l14.6-4.6l5.3,17.8
                  c0,0,30.5-0.1,49.4-0.4c18.9-0.3,20.2-3.5,26.2-6.5S525,155.7,525,155.7l-2-5.8l19.3-6.9l2.1,6.9l13.5,36.1l1.6-0.6l4.6,14.3
                  l-19.2,7.3l-2-4.9l-168.6,194" />
            <path
                class="fill-none stroke-woom-black stroke-2"
                d="M321.4,241.8c0,0,43.8-0.2,51.2-0.2c7.4,0,17.4-3.6,29.1-9s130-62,130-62l2.8,7.1l-171,196.8L321.4,241.8z" />
            <line
                class="fill-none stroke-woom-black stroke-2"
                x1="544.8"
                y1="207.1"
                x2="557"
                y2="236.4" />
            <polyline
                class="fill-none stroke-woom-black stroke-2"
                points="585.1,247.3 634.6,348.1 623.5,353.9 573.3,263.7 568.9,255.6" />
            <path
                class="fill-none stroke-woom-black stroke-2"
                d="M559.1,236l-8.5-16.4c0,0-2.4-7.2,6.4-10.9c8.5-3.4,13.1,7.9,13.1,7.9l5.5,11.1" />
            <line
                class="fill-none stroke-woom-black stroke-2"
                x1="564"
                y1="199.8"
                x2="568.4"
                y2="212.9" />
            <polyline
                class="fill-none stroke-woom-black stroke-2"
                points="522.9,149.9 520.7,144.2 536.5,138.2 541.6,140.8 542.2,143" />
            <path
                class="fill-none stroke-woom-black stroke-2"
                d="M575.5,227.8c18.1-7.9,38.1-12.2,59.1-12.2c82,0,148.4,66.4,148.4,148.4s-66.4,148.4-148.4,148.4
                  S486.2,446,486.2,364c0-54.4,29.3-101.9,72.9-127.8l9.8,19.4c-36.6,22.2-61,62.4-61,108.4c0,70,56.7,126.7,126.7,126.7
                  S761.3,434,761.3,364s-56.7-126.7-126.7-126.7c-17.6,0-34.3,3.6-49.5,10L575.5,227.8z" />
            <path
                class="fill-none stroke-woom-black stroke-2"
                d="M310.6,394.7c-14.2,67.2-73.8,117.7-145.2,117.7C83.4,512.4,17,446,17,364s66.4-148.4,148.4-148.4
                  c51.5,0,96.9,26.3,123.5,66.2" />
            <path
                class="fill-none stroke-woom-black stroke-2"
                d="M293.7,289.4c12.7,21.9,20.1,47.4,20.1,74.5c0,5.9-0.3,11.8-1,17.5" />
            <path
                class="fill-none stroke-woom-black stroke-2"
                d="M289.3,390.6c-12.2,57.2-63.1,100.1-123.9,100.1c-70,0-126.7-56.7-126.7-126.7s56.7-126.7,126.7-126.7
                  c43.4,0,81.7,21.8,104.5,55.1" />
            <path
                class="fill-none stroke-woom-black stroke-2"
                d="M274.4,299.3c11.2,18.9,17.7,41,17.7,64.6c0,4.8-0.3,9.6-0.8,14.3" />
            <path
                class="fill-none stroke-woom-black stroke-2"
                d="M411.6,438.9l-44.7-50c-0.1-0.1-0.2-0.2-0.3-0.3c-1.1-0.9-6.9-4.9-12.4,1.1c-5.3,5.8-1.5,11.5,3.6,15.6
                  c3.5,2.8,24.4,21.9,37.2,33.6" />
            <path
                class="fill-none stroke-woom-black stroke-2"
                d="M411.6,438.9" />
            <path
                class="fill-none stroke-woom-black stroke-2"
                d="M413.8,446.8" />
            <path
                class="fill-none stroke-woom-black stroke-2"
                d="M404.3,447.1c0,0,4.8,4.3,8.3,1c0.5-0.4,0.6-0.6,0.9-1" />
            <path
                class="fill-none stroke-woom-black stroke-2"
                d="M394.9,438.9" />
            <path
                class="fill-none stroke-woom-black stroke-2"
                d="M312.4,343.7c0,0,2.8-1.7,5.6,1.1c2.8,2.8,25,22.9,25,22.9" />
            <line
                class="fill-none stroke-woom-black stroke-2"
                x1="313.8"
                y1="358.1"
                x2="338.7"
                y2="384.9" />
            <polyline
                class="fill-none stroke-woom-black stroke-2"
                points="403.7,447 386.9,447 386.9,438.9 428.9,438.9 428.9,447 403.7,447" />
            <polyline
                class="fill-none stroke-woom-black stroke-2"
                points="319.3,345.6 333.7,345.6 333.7,353.7 327.7,353.7" />
            <path
                class="fill-none stroke-woom-black stroke-2"
                d="M624.4,353.4c-0.1,0.1,0.1,2.4,0.1,2.4l5.9,11.4c0,0,3.8,2.7,5,2.1s-1.8-5.6-1.8-5.6s-0.9-2.3,0.6-3
                  c1.5-0.6,2.8,0.8,3.3,1.8c0.5,1.1,2.6,4.3,2.6,4.3s3-0.7,1.7-4.8c-1.3-4.1-5.5-11.7-5.5-11.7l-3-1" />
            <path
                class="fill-none stroke-woom-black stroke-2"
                old-class="hidden"
                d="M443.4,311.3l-0.9,0.8c-0.2,0.2-0.4,0.2-0.7,0l-6.9-3.6c-2.3-1.2-5-1.2-7.2,0.9c-1.1,1-1.7,2.5-1.8,4
                  c-1.7,0.1-3.2,0.8-4.1,1.7c-2.2,2.2-2.7,4.9-1.4,7.1c-2.7-0.8-5.7-0.2-7.9,1.8c-2.1,2-2.8,4.8-2.2,7.5c-2.6-0.7-5.5-0.1-7.6,1.9
                  s-2.8,4.8-2.2,7.5l-1.4-1.4c-0.7-0.8-1.9-0.8-2.7-0.1c-0.8,0.7-0.8,1.9-0.1,2.7l5.7,5.9c0.8,0.9,0.6,2.3-0.2,3.1
                  c-0.8,0.8-2.3,0.9-3.1,0.1l-0.1-0.1l-5.6-5.8c-0.7-0.8-1.9-0.8-2.7-0.1c-0.8,0.7-0.8,1.9-0.1,2.7l5.6,5.8l0.1,0.1
                  c0.9,1,0.6,2.4-0.1,3s-1.6,0.9-2.9,0.2l-7.5-3.9c-1.8-1-3.3,0-3.9,0.5L380,355c-0.8,0.7-0.8,1.9-0.1,2.6c0.7,0.8,1.9,0.7,2.7,0
                  l0.9-0.8c0.2-0.2,0.4-0.2,0.7,0l6.9,3.6c2.3,1.2,5,1.2,7.2-0.9c1.1-1,1.7-2.5,1.8-4c1.7-0.1,3.2-0.8,4.1-1.7
                  c2.2-2.2,2.7-4.9,1.4-7.1c2.7,0.8,5.7,0.2,7.9-1.8c2.1-2,2.8-4.9,2.2-7.5c2.6,0.7,5.5,0.1,7.6-1.9s2.8-4.9,2.2-7.5l1.4,1.4
                  c0.7,0.8,1.9,0.8,2.7,0.1c0.8-0.7,0.8-1.9,0.1-2.7l-5.7-5.9c-0.8-0.9-0.6-2.3,0.2-3.1c0.8-0.8,2.3-0.9,3.1-0.1l0.1,0.1l5.6,5.8
                  c0.7,0.8,1.9,0.8,2.7,0.1c0.8-0.7,0.8-1.9,0.1-2.7l-5.6-5.8l-0.1-0.1c-0.9-1-0.6-2.4,0.1-3s1.6-0.9,2.9-0.2l7.5,3.9
                  c1.8,1,3.3,0,3.9-0.5l1.5-1.4c0.8-0.7,0.8-1.9,0.1-2.6C445.3,310.5,444.1,310.5,443.4,311.3z M411,342.2c-1.6,1.6-4.3,1.5-5.9-0.1
                  c-1.6-1.7-1.5-4.3,0.1-5.9c1.7-1.6,4.3-1.5,5.9,0.1C412.7,338,412.7,340.6,411,342.2z M420.8,332.8c-1.6,1.6-4.3,1.5-5.9-0.1
                  c-1.6-1.7-1.5-4.3,0.1-5.9c1.7-1.6,4.3-1.5,5.9,0.1C422.5,328.6,422.5,331.2,420.8,332.8z" />
            <circle
                class="fill-none stroke-woom-black stroke-2"
                old-class="inline"
                cx="361.1"
                cy="395.6"
                r="5.4" />
        </g>
        <g class="saddle-normal">
            <line
                class="fill-none stroke-woom-black stroke-2"
                x1="310.2"
                y1="209.3"
                x2="297.7"
                y2="169.7" />
            <line
                class="fill-none stroke-woom-black stroke-2"
                x1="298.7"
                y1="212.6"
                x2="286.5"
                y2="172" />
            <path
                class="fill-none stroke-woom-black stroke-2"
                d="M248.6,143.4c0,0,81.2,2.6,89.3,2.6s14.3,5.4,12.8,8.7s-5.1,2-9.4,1.9s-20.5-2.5-35.7,2.4
                  c-15.1,4.9-20.3,11.5-34.8,11s-26.1-7.8-28.8-14C239.3,149.8,240.7,143.8,248.6,143.4z" />
            <path
                class="fill-none stroke-woom-black stroke-2"
                d="M273.4,170.7c0,0,1.4,2.2,5.9,1.6c4.5-0.6,20.3-2.3,26-4.6c5.6-2.3,18.3-11.4,18.3-11.4" />
        </g>
        <g class="handlebar-normal">
            <path
                class="fill-none stroke-woom-black stroke-2"
                d="M520.7,144.2l-3.9-8.6l1.4-4.9 M538.7,133c-3.6,2.2-2.2,5.2-2.2,5.2 M530,114.7c0,0,0.1,0.6,0.6,1.5
                  c10.2-2.5,14.8,7.1,14.8,7.1l-1.4,3l3.7,1.6c0,0,5.1-4.3,7.3-7.4s0.8-9.2-3.9-9.8s-7.4-0.8-14.6-5.5 M515.6,87.7
                  c-6,0-10.9,4.9-10.9,10.9s4.9,10.9,10.9,10.9c4.5,0,8.4-2.8,10-6.7c0.5-1.3,0.8-2.7,0.8-4.2C526.4,92.5,521.6,87.7,515.6,87.7z
                  M524.8,104.2c0,0-0.1-1.1-0.1,4.1s4,6.4,6.3,6.4s5.2-2.4,5.2-5s-0.4-6.3-1.1-11.7c-0.7-5.4-5.8-4.8-9.7-4.8 M529.8,92.8
                  c-3.1-4-7.2-2.5-7.2-2.5 M549.4,113.3c-2,0-3.7,1.7-3.7,3.7s1.7,3.7,3.7,3.7s3.7-1.7,3.7-3.7S551.4,113.3,549.4,113.3z" />
            <line
                class="fill-none stroke-woom-black stroke-2"
                x1="518.2"
                y1="130.8"
                x2="537.7"
                y2="116.7" />
            <path
                class="fill-none stroke-woom-black stroke-2"
                d="M546,127.6c-3,2.2-5.7,4.2-7.3,5.4" />
        </g>
        <g class="tyres hidden">
            <g class="inline">
                <g>
                    <g>
                        <line
                            class="h-line fill-none stroke-woom-red stroke-3"
                            x1="164.9"
                            y1="215.6"
                            x2="164.9"
                            y2="512.3" />
                        <g>
                            <rect
                                x="157.1"
                                y="214.4"
                                class="fill-woom-red stroke-woom-red"
                                width="15.6"
                                height="2.4" />
                        </g>
                        <g>
                            <rect
                                x="157.1"
                                y="511.1"
                                class="fill-woom-red stroke-woom-red"
                                width="15.6"
                                height="2.4" />
                        </g>
                    </g>
                </g>
            </g>
            <g class="inline">
                <g>
                    <g>
                        <line
                            class="h-line fill-none stroke-woom-red stroke-3"
                            x1="630"
                            y1="215.6"
                            x2="630"
                            y2="512.3" />
                        <g>
                            <rect
                                x="622.2"
                                y="214.4"
                                class="fill-woom-red stroke-woom-red"
                                width="15.6"
                                height="2.4" />
                        </g>
                        <g>
                            <rect
                                x="622.2"
                                y="511.1"
                                class="fill-woom-red stroke-woom-red"
                                width="15.6"
                                height="2.4" />
                        </g>
                    </g>
                </g>
            </g>
        </g>
        <g class="cockpit hidden">
            <g class="inline">
                <g>
                    <g>
                        <line
                            class="h-line fill-none stroke-woom-red stroke-3"
                            x1="515.8"
                            y1="98.5"
                            x2="515.8"
                            y2="512.3" />
                        <g>
                            <rect
                                x="508"
                                y="97.3"
                                class="fill-woom-red stroke-woom-red"
                                width="15.6"
                                height="2.4" />
                        </g>
                        <g>
                            <rect
                                x="508"
                                y="511.1"
                                class="fill-woom-red stroke-woom-red"
                                width="15.6"
                                height="2.4" />
                        </g>
                    </g>
                </g>
            </g>
        </g>
        <g class="steering-angle hidden">
            <g class="inline">
                <g>
                    <polyline
                        class="h-line fill-none stroke-woom-red stroke-3"
                        points="494.3,73.5 553.3,199.6 428.2,199.6" />
                </g>
                <path
                    class="h-line-miter fill-none stroke-woom-red stroke-3"
                    d="M504.3,199.3c0-19.5,11.6-36.4,28.2-44" />
            </g>
            <g class="inline">
                <g>
                    <g>
                        <g>
                            <line
                                class="h-line fill-none stroke-woom-red stroke-3"
                                x1="555.9"
                                y1="206.3"
                                x2="557.8"
                                y2="209.9" />
                            <line
                                class="h-dash-line fill-none stroke-woom-red stroke-3"
                                x1="561.5"
                                y1="217.2"
                                x2="708.2"
                                y2="505" />
                            <polyline
                                class="h-line fill-none stroke-woom-red stroke-3"
                                points="710.1,508.6 711.9,512.2 707.9,512.2" />
                            <line
                                class="h-dash-line fill-none stroke-woom-red stroke-3"
                                x1="699.7"
                                y1="512.2"
                                x2="588.9"
                                y2="512.2" />
                            <line
                                class="h-line fill-none stroke-woom-red stroke-3"
                                x1="584.8"
                                y1="512.2"
                                x2="580.8"
                                y2="512.2" />
                        </g>
                    </g>
                </g>
                <g>
                    <g>
                        <path
                            class="h-line fill-none stroke-woom-red stroke-3"
                            d="M656.3,512.3c0-1.3,0.1-2.7,0.2-4" />
                        <path
                            class="h-dash-line fill-none stroke-woom-red stroke-3"
                            d="M658.2,499c3.1-10.8,9.8-20.1,18.8-26.4" />
                        <path
                            class="h-line fill-none stroke-woom-red stroke-3"
                            d="M681,470.2c1.2-0.7,2.3-1.3,3.6-1.8" />
                    </g>
                </g>
            </g>
        </g>
        <g class="top-tube-horizontal hidden">
            <g class="inline">
                <g>
                    <g>
                        <line
                            class="h-line fill-none stroke-woom-red stroke-3"
                            x1="529.2"
                            y1="132.4"
                            x2="292.6"
                            y2="132.4" />
                        <g>
                            <rect
                                x="528"
                                y="124.6"
                                class="fill-woom-red stroke-woom-red"
                                width="2.4"
                                height="15.6" />
                        </g>
                        <g>
                            <rect
                                x="291.4"
                                y="124.6"
                                class="fill-woom-red stroke-woom-red"
                                width="2.4"
                                height="15.6" />
                        </g>
                    </g>
                </g>
            </g>
        </g>
        <g class="wheelbase hidden">
            <g class="inline">
                <g>
                    <g>
                        <line
                            class="h-line fill-none stroke-woom-red stroke-3"
                            x1="634"
                            y1="360.8"
                            x2="167.9"
                            y2="360.8" />
                        <g>
                            <rect
                                x="632.8"
                                y="353"
                                class="fill-woom-red stroke-woom-red"
                                width="2.4"
                                height="15.6" />
                        </g>
                        <g>
                            <rect
                                x="166.7"
                                y="353"
                                class="fill-woom-red stroke-woom-red"
                                width="2.4"
                                height="15.6" />
                        </g>
                    </g>
                </g>
            </g>
        </g>
        <g class="seat-tube-angle hidden">
            <g class="inline">
                <polyline
                    class="h-line-miter fill-none stroke-woom-red stroke-3"
                    points="308.3,223.2 395.3,512.3 164.2,512.3" />
            </g>
            <path
                class="h-line-miter fill-none stroke-woom-red stroke-3"
                d="M348.4,511.2c0-22.2,12.2-39.6,31.1-48.3" />
        </g>
        <g class="min-saddle-height hidden">
            <g class="inline">
                <g>
                    <g>
                        <g>
                            <line
                                class="h-line fill-none stroke-woom-red stroke-3"
                                x1="291"
                                y1="164.3"
                                x2="286.6"
                                y2="164.3" />
                            <line
                                class="h-dash-line fill-none stroke-woom-red stroke-3"
                                x1="277.7"
                                y1="164.3"
                                x2="32"
                                y2="164.3" />
                            <line
                                class="h-line fill-none stroke-woom-red stroke-3"
                                x1="27.6"
                                y1="164.3"
                                x2="23.1"
                                y2="164.3" />
                        </g>
                    </g>
                </g>
                <g>
                    <g>
                        <g>
                            <g>
                                <line
                                    class="h-line fill-none stroke-woom-red stroke-3"
                                    x1="10"
                                    y1="164.3"
                                    x2="10"
                                    y2="512.3" />
                                <g>
                                    <rect
                                        x="2.2"
                                        y="163.1"
                                        class="fill-woom-red stroke-woom-red"
                                        width="15.6"
                                        height="2.4" />
                                </g>
                                <g>
                                    <rect
                                        x="2.2"
                                        y="511.1"
                                        class="fill-woom-red stroke-woom-red"
                                        width="15.6"
                                        height="2.4" />
                                </g>
                            </g>
                        </g>
                    </g>
                </g>
            </g>
            <g class="inline">
                <line
                    class="fill-none stroke-woom-black stroke-2"
                    x1="310.2"
                    y1="209.3"
                    x2="303.7"
                    y2="189.7" />
                <line
                    class="fill-none stroke-woom-black stroke-2"
                    x1="298.7"
                    y1="212.6"
                    x2="292.5"
                    y2="192" />
                <path
                    class="fill-none stroke-woom-black stroke-2"
                    d="M254.6,163.4c0,0,81.2,2.6,89.3,2.6s14.3,5.4,12.8,8.7s-5.1,2-9.4,1.9s-20.5-2.5-35.7,2.4
                      c-15.1,4.9-20.3,11.5-34.8,11s-26.1-7.8-28.8-14C245.3,169.8,246.7,163.8,254.6,163.4z" />
                <path
                    class="fill-none stroke-woom-black stroke-2"
                    d="M279.4,190.7c0,0,1.4,2.2,5.9,1.6c4.5-0.6,20.3-2.3,26-4.6c5.6-2.3,18.3-11.4,18.3-11.4" />
            </g>
        </g>
        <g class="max-saddle-height hidden">
            <g class="inline">
                <g>
                    <g>
                        <line
                            class="h-line fill-none stroke-woom-red stroke-3"
                            x1="10"
                            y1="125.5"
                            x2="10"
                            y2="512.3" />
                        <g>
                            <rect
                                x="2.2"
                                y="124.3"
                                class="fill-woom-red stroke-woom-red"
                                width="15.6"
                                height="2.4" />
                        </g>
                        <g>
                            <rect
                                x="2.2"
                                y="511.1"
                                class="fill-woom-red stroke-woom-red"
                                width="15.6"
                                height="2.4" />
                        </g>
                    </g>
                </g>
                <g>
                    <g>
                        <line
                            class="h-line fill-none stroke-woom-red stroke-3"
                            x1="291"
                            y1="125.5"
                            x2="286.4"
                            y2="125.5" />
                        <line
                            class="h-dash-line fill-none stroke-woom-red stroke-3"
                            x1="276.8"
                            y1="125.5"
                            x2="32.6"
                            y2="125.5" />
                        <line
                            class="h-line fill-none stroke-woom-red stroke-3"
                            x1="27.8"
                            y1="125.5"
                            x2="23.1"
                            y2="125.5" />
                    </g>
                </g>
            </g>
            <g class="inline">
                <line
                    class="fill-none stroke-woom-black stroke-2"
                    x1="310.2"
                    y1="209.3"
                    x2="291.7"
                    y2="149.7" />
                <line
                    class="fill-none stroke-woom-black stroke-2"
                    x1="298.7"
                    y1="212.6"
                    x2="280.5"
                    y2="152" />
                <path
                    class="fill-none stroke-woom-black stroke-2"
                    d="M242.6,123.4c0,0,81.2,2.6,89.3,2.6s14.3,5.4,12.8,8.7s-5.1,2-9.4,1.9s-20.5-2.5-35.7,2.4
                      c-15.1,4.9-20.3,11.5-34.8,11s-26.1-7.8-28.8-14C233.3,129.8,234.7,123.8,242.6,123.4z" />
                <path
                    class="fill-none stroke-woom-black stroke-2"
                    d="M267.4,150.7c0,0,1.4,2.2,5.9,1.6c4.5-0.6,20.3-2.3,26-4.6c5.6-2.3,18.3-11.4,18.3-11.4" />
            </g>
        </g>
        <g class="crank-length hidden">
            <g class="inline">
                <line
                    class="h-line fill-none stroke-woom-red stroke-3"
                    x1="361.3"
                    y1="396.1"
                    x2="408.2"
                    y2="444.1" />
                <g>
                    <rect
                        x="353.5"
                        y="394.9"
                        transform="matrix(0.7154 -0.6987 0.6987 0.7154 -173.9143 365.1844)"
                        class="fill-woom-red stroke-woom-red"
                        width="15.6"
                        height="2.4" />
                </g>
                <g>
                    <rect
                        x="400.4"
                        y="442.9"
                        transform="matrix(0.7154 -0.6987 0.6987 0.7154 -194.1016 411.5999)"
                        class="fill-woom-red stroke-woom-red"
                        width="15.6"
                        height="2.4" />
                </g>
            </g>
        </g>
        <g class="handlebar-adjustability hidden">
            <g class="inline">
                <g>
                    <g>
                        <g>
                            <path
                                class="h-line fill-none stroke-woom-red stroke-3"
                                d="M534.9,37.6c23.4,2.1,42,20.7,44.1,44.1" />
                            <g>
                                <polygon
                                    class="fill-woom-red stroke-woom-red"
                                    points="536.2,43.7 526.4,36.8 537.2,31.8" />
                            </g>
                            <g>
                                <polygon
                                    class="fill-woom-red stroke-woom-red"
                                    points="572.9,80.5 579.8,90.3 584.8,79.4" />
                            </g>
                        </g>
                    </g>
                </g>
            </g>
            <path
                class="fill-none stroke-woom-black stroke-2"
                d="M520.7,144.2l-3.9-8.6l1.4-4.9l24-17.2 M553.1,122.5c0,0-10.9,7.9-14.3,10.5
                  c-3.3,2.6-2.2,5.2-2.2,5.2 M537.3,101.7c0,0-0.3,0.5-0.7,1.5c9,5.5,5.4,15.5,5.4,15.5l-3.1,1.2l1.4,3.8c0,0,6.6,0.6,10.4-0.1
                  c3.7-0.7,7-5.9,4.1-9.7s-4.7-5.8-6.4-14.2 M546.3,72.3c-4.2-4.2-11.1-4.3-15.4,0s-4.3,11.1,0,15.4c3.2,3.2,7.9,4,11.8,2.4
                  c1.3-0.5,2.5-1.3,3.6-2.4C550.5,83.5,550.5,76.6,546.3,72.3z M541.1,90.6c0,0,0.7-0.8-2.9,2.8c-3.7,3.6-1.7,7.4-0.1,9
                  c1.6,1.6,5.4,2,7.2,0.2s4.2-4.8,7.5-9.1c3.3-4.3-0.7-7.5-3.4-10.3 M552.7,86c0.7-5-3.3-6.9-3.3-6.9 M552,114.4
                  c-1.4-1.4-3.8-1.4-5.2,0s-1.4,3.8,0,5.2s3.8,1.4,5.2,0S553.4,115.9,552,114.4z" />
        </g>
        <g class="stand-over-height hidden">
            <g class="inline">
                <g>
                    <g>
                        <line
                            class="h-line fill-none stroke-woom-red stroke-3"
                            x1="10"
                            y1="213"
                            x2="10"
                            y2="512.3" />
                        <g>
                            <rect
                                x="2.2"
                                y="211.8"
                                class="fill-woom-red stroke-woom-red"
                                width="15.6"
                                height="2.4" />
                        </g>
                        <g>
                            <rect
                                x="2.2"
                                y="511.1"
                                class="fill-woom-red stroke-woom-red"
                                width="15.6"
                                height="2.4" />
                        </g>
                    </g>
                </g>
            </g>
            <g class="inline">
                <line
                    class="h-line fill-none stroke-woom-red stroke-3"
                    x1="405.5"
                    y1="212.9"
                    x2="400.8"
                    y2="212.9" />
                <line
                    class="h-dash-line fill-none stroke-woom-red stroke-3"
                    x1="391.2"
                    y1="212.9"
                    x2="32.4"
                    y2="212.9" />
                <line
                    class="h-line fill-none stroke-woom-red stroke-3"
                    x1="27.6"
                    y1="212.9"
                    x2="22.9"
                    y2="212.9" />
            </g>
        </g>
    </svg>
</template>
